<div class="card-grid" role="list">
    <app-reporting-card *ngFor="let report of exports" [report]="report" />
</div>
